<template>
  <div>
    <template v-if="!isLoading && !emptyFeedback">
      <template v-if="routeTo">
        <router-link
          v-for="(item, index) in groups"
          :key="index"
          :to="editRouteTo(item.id)"
        >
          <b-badge
            pill
            :variant="color"
            class="ml-1"
          >
            {{item.name}}
          </b-badge>
        </router-link>
        <template v-if="!isLoading && !groups.length">N/A</template>
      </template>
      <template v-else>
        <b-badge
          v-for="(item, index) in groups"
          :key="index"
          pill
          :variant="color"
          class="ml-1 cursor-pointer"
          @click="openEditModal(item.id)"
        >
          {{item.name}}
        </b-badge>
        <template v-if="!isLoading && !groups.length">N/A</template>
      </template>
    </template>
    <b-skeleton v-else-if="isLoading && !emptyFeedback"></b-skeleton>

    <b-modal
      :id="modalCreatorId"
      size="xl"
      scrollable
      hide-header
      hide-footer
      :cancel-title="$t('cancel')"
      :ok-title="$t('confirm')"
    >
      <component
        ref="creatorFormComponent"
        :is="formComponent"
        :isOnModal="true"
        :isOnEditMode="true"
        :editItemId="editItemId"
        @itemUpdated="onItemUpdated"
        @closeModal="$bvModal.hide(modalCreatorId)"
      />
    </b-modal>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    value: {
      type: String,
      required: true
    },
    endpoint: {
      type: String,
      required: true
    },
    formComponent: {
      type: String
    },
    routeTo: {
      type: String
    },
    color: {
      type: String,
      default: 'primary'
    },
    onReloadEmit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isLoading: false,
      groups: [],
      editItemId: null,
      modalCreatorId: '',
      userInfo: null,
      emptyFeedback: false
    }
  },
  computed: {
    date () {
      if (this.value?.date) {
        return moment(this.value.date).format('DD-MM-YYYY HH:mm')
      }
      return null
    },
    userId () {
      return this?.value || null
    },
    showBadge () {
      return typeof this.value.user === 'object' && 'done' in this.value.user
    },
    badgeVariant () {
      if (this.showBadge) {
        return this.value.user.done === false ? 'danger' : 'success'
      }
      return null
    },
    badgeIcon () {
      if (this.showBadge) {
        return this.value.user.done === false ? 'dash-circle' : 'check'
      }
      return null
    }
  },
  methods: {
    onItemUpdated () {
      if (this.onReloadEmit) {
        this.$emit('onReload')
      } else {
        this.$bvModal.hide(this.modalCreatorId)
        this.loadData()
      }
    },
    openEditModal (id) {
      this.editItemId = id
      this.$bvModal.show(this.modalCreatorId)
    },
    editRouteTo (id) {
      return `${this.routeTo}${id}`
    },
    async loadData () {
      try {
        const res = await commonsApi.axiosGetWrapper(`${this.endpoint}${this.userId}`)
        if (res.data.length > 0) {
          this.groups = res.data
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.userId) {
        await this.loadData()
      } else {
        this.emptyFeedback = true
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  },
  mounted () {
    // Genera un ID aleatorio cuando el componente se monta
    this.modalCreatorId = 'badge-with-link-modal-' + Math.random().toString(36).substring(2, 9)
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
